<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-21 15:21:31
 * @LastEditTime: 2022-02-22 23:46:31
 * @LastEditors: chenguobiao
-->
<template>
  <div class="player-detail">
    <player-info ref="aiPlayer" :captures="aiCaptures" :user-info="aiUserInfo"></player-info>
    <player-info ref="manPlayer" :user-info="manUserInfo" :captures="manCaptures" :time="time" @timeOver="manTimeOver"></player-info>
  </div>
</template>

<script>
import store from 'store'
import { CHESS_NUMERICAL_VALUE, WS_GAME_CONFIGS } from '@/config/const'
import PlayerInfo from './PlayerInfo'
export default {
  name: 'PlayerDetail',
  props: {
    aiUserInfo: { type: Object, default: () => ({}) },
    manUserInfo: { type: Object, default: () => ({}) },
    captures: { type: Object, default: () => ({}) },
    time: { type: String },
    turn: { type: String }
  },
  data() {
    return {
      configs: {},
      aiCaptures: [],
      manCaptures: [],
    }
  },
  components: {
    PlayerInfo
  },
  watch: {
    captures: {
      deep: true,
      handler(val) {
        const valNew = JSON.parse(JSON.stringify(val))
        const { player_turn, other_side_turn } = store.get(WS_GAME_CONFIGS)
        const aiCaptures = valNew[player_turn] ? valNew[player_turn].value : []
        const manCaptures = valNew[other_side_turn] ? valNew[other_side_turn].value : []
        if (typeof valNew[player_turn] === 'object') {
          this.aiCaptures = this.sortCaptures(aiCaptures)
          this.manCaptures = this.sortCaptures(manCaptures)
        }
      }
    },
    turn: {
      immediate: true,
      handler(val) {
        if (val) {
          const playerCol = store.get(WS_GAME_CONFIGS).player_turn
          const replay = store.get(WS_GAME_CONFIGS).replay
          if (replay) return
          this.$nextTick(() => {
            const manPlayer = this.$refs.manPlayer
            const { minutes, seconds } = manPlayer.$refs.clock
            console.log('minutes', minutes, 'seconds', seconds)
            if (val === playerCol) {
              manPlayer.start()
            } else {
              manPlayer.stop()
            }
          })
        }
      }
    }
  },
  methods: {
    sortCaptures(captures) {
      return captures.sort((a, b) => {
        const a_weight = CHESS_NUMERICAL_VALUE[a.captured.toLowerCase()].weight
        const b_weight = CHESS_NUMERICAL_VALUE[b.captured.toLowerCase()].weight
        return a_weight - b_weight
      })
    },
    manTimeOver(val) {
      const playerCol = store.get(WS_GAME_CONFIGS).player_turn
      if (val) {
        this.$emit('manTimeOver', playerCol)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .player-detail {
    width: val(380);
    ::v-deep .userinfo {
      max-width: val(240);
      overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    ::v-deep .countdown {
      width: val(120);
      margin-right: val(25);
    }
  }
</style>
